var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4697 0.0466475C20.0505 -0.144223 9.72063 9.80062 9.45639 22.217C9.32916 28.2221 11.5361 33.7084 15.2354 37.8341C15.9205 38.5976 25.9665 49.5849 30.2286 54.2441C31.2415 55.3551 32.9884 55.3551 34.0014 54.2441C38.2635 49.5849 48.3095 38.5976 48.9945 37.8341C52.5911 33.821 54.7785 28.5206 54.7785 22.7113C54.7785 10.3096 44.8205 0.232624 32.4697 0.0466475ZM32.1125 33.8699C25.9518 33.8699 20.9557 28.873 20.9557 22.7113C20.9557 16.5496 25.9518 11.5527 32.1125 11.5527C38.2732 11.5527 43.2693 16.5496 43.2693 22.7113C43.2693 28.873 38.2732 33.8699 32.1125 33.8699Z",
    fill: "#F7B01A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2768 64.9574C60.9 64.9574 60.5183 64.8791 60.1562 64.7127L48.6422 59.4662L32.9835 64.8155C32.4159 65.0113 31.8042 65.0113 31.2366 64.8155L15.5779 59.4662L4.06386 64.7127C2.70352 65.3343 1.0985 64.7323 0.481942 63.3717C-0.139512 62.0112 0.462368 60.4059 1.82272 59.7892L14.3154 54.0974C14.9417 53.8086 15.6562 53.7744 16.3119 53.9995L32.1125 59.3977L47.9131 53.9995C48.5688 53.7744 49.2783 53.8135 49.9095 54.0974L62.4022 59.7892C63.7626 60.4108 64.3596 62.0112 63.743 63.3717C63.2879 64.3701 62.3044 64.9574 61.2768 64.9574Z",
    fill: "#DCDADD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocation);
export default __webpack_public_path__ + "static/media/contact_location.590a79c0e719805cf399ae269f10ce68.svg";
export { ForwardRef as ReactComponent };